import '../shared';
import './stores';
import './components';

import { initSectionWhenUserInteracts } from '../../auto/utils/initSectionWhenUserInteracts';

window.helpers = {
  ...window.helpers,
  initSectionWhenUserInteracts,
};
